import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import CardBalance from "../../MyAccount/AccountCard/CardBalance";
import useFinalizeManager from "../hooks/useFinalizeManager";
import "./style.scss";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  handleSetPayment: (type: string) => void;
}

const EcardButton: React.FC<IProps> = ({ handleSetPayment }: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { calculateEcard } = useFinalizeManager(() => {});
  const { t } = useTranslation();

  return (
    <>
      {saleConfiguration.ecard_PayByEcard && (
        <>
          <p className="or">{t("lub")}</p>

          <div className="ecard-payment flex-column">
            <EAButton
              title={`${t("zaplac")} ${saleConfiguration.giftCard3Message}`}
              onClick={() => {
                handleSetPayment("ecard");
                calculateEcard();
              }}
              variant="outlined"
              fullWidth
            />
            <b className="flex-start">
              {t("dostepne_srodki")}:
              <CardBalance />
            </b>
          </div>

          {/* 
          <div className="ecard">
            <div className="button button-ecard button-outline-main flex-between-center">
              <div className="flex-start-center">
                <MdCardGiftcard className="big-icon" />
                <div className="ecard-text">
                  <b>
                    {t("zaplac")} {saleConfiguration.giftCard3Message}
                  </b>
                  <span className="flex-column flex-start">
                    {t("dostepne_srodki")}:
                    <CardBalance />
                  </span>
                </div>
              </div>
              <EAButton
                title={t("wybierz")}
                onClick={() => {
                  handleSetPayment("ecard");
                  calculateEcard();
                }}
                fullWidth
              />
            </div>
          </div> */}
        </>
      )}
    </>
  );
};

export default EcardButton;
